/**
 * Encodes a Uint8Array to a Base64 string.
 * Uses the browser's built-in btoa function for encoding.
 *
 * @param data - Bytes to encode
 * @returns Base64 encoded string
 *
 * @example
 * ```ts
 * import { Base64Encode } from "@pdfking/tfunc"
 *
 * const bytes = new TextEncoder().encode("Hello World")
 * const encoded = Base64Encode(bytes) // "SGVsbG8gV29ybGQ="
 * ```
 */
export const Base64Encode = (data: Uint8Array): string =>
  btoa(String.fromCharCode(...data))
